/**
 * @param {string} str
 * @returns {boolean}
 */
const dataPrefixed = (str) => str.startsWith('data:');

/**
 * @param {string=} str
 * @returns {boolean}
 */
const empty = (str) => !str;

/**
 * @param {string} str
 * @returns {boolean}
 */
const decodable = (str) => {
    try {
        window.atob(str);
        return true;
    } catch (e) {
        return false;
    }
};

/**
 * Best effort validation that checks that the string contains a base64 string that can be decoded.
 *
 * @param {string} str
 * @returns {boolean}
 */
export const isValidBase64Data = (str) => {
    if (empty(str)) {
        return false;
    }

    const [dataMimeTypePart, base64Part] = str.split(',');

    if (empty(dataMimeTypePart) || empty(base64Part)) {
        return false;
    }

    if (!dataPrefixed(dataMimeTypePart)) {
        return false;
    }

    return decodable(base64Part);
};
